// removed by extract-text-webpack-plugin
module.exports = {"content":"Documents__content__2YvLL","parentContainer":"Documents__parentContainer__2Ixaj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Documents/Documents.css
// module id = 1020
// module chunks = 0